module.exports = __webpack_public_path__ + "static/media/mission.de03a008.jpg";